import type { IntlService } from 'ember-intl';
import type { PhoneVerificationState } from 'tio-data/data/resources/phone-number.type';

/**
 * The mobile-number attention row's inputs for a verification state, resolved in one place
 * because two dashboards render the same row.
 *
 * A member who already typed a number is asked to finish rather than to add; the reason to
 * have one on file does not change, so the description is shared.
 */
export function phoneCaptureCard(intl: IntlService, state: PhoneVerificationState) {
  const variant = state === 'unverified' ? 'dashboard_card.resume' : 'dashboard_card';

  return {
    state,
    title: intl.t(`phone_verification.${variant}.title`),
    description: intl.t('phone_verification.dashboard_card.description'),
    cta: intl.t(`phone_verification.${variant}.cta`),
  };
}
